import { BaseQueryFn } from '@reduxjs/toolkit/query/react';
import { correlateApi } from '@/utils/api';

export enum HttpMethod {
  DELETE = 'DELETE',
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
}
export interface BaseQueryArgs {
  url: string;
  method?: HttpMethod;
  body?: any;
  params?: any;
}

export interface BaseQueryError {
  status: number;
  data: any;
}

// Custom base query using existing correlateApi directly
export const createBaseQuery = (): BaseQueryFn<string | BaseQueryArgs, any, BaseQueryError> => async (args: string | BaseQueryArgs, _api, _extraOptions) => {
  try {
    const { url, method = HttpMethod.GET, body, params } = typeof args === 'string' ? { url: args, method: HttpMethod.GET } : args;

    let response;

    switch (method) {
      case HttpMethod.GET:
        response = await correlateApi.get(url, { params });
        break;
      case HttpMethod.POST:
        response = await correlateApi.post(url, body);
        break;
      case HttpMethod.PUT:
        response = await correlateApi.put(url, body);
        break;
      case HttpMethod.DELETE:
        response = await correlateApi.delete(url);
        break;
      case HttpMethod.PATCH:
        response = await correlateApi.patch(url, body);
        break;
      default:
        throw new Error(`Unsupported method: ${method}`);
    }

    return { data: response };
  } catch (error: any) {
    return {
      error: {
        status: error.response?.status || 500,
        data: error.response?.data || error.message,
      },
    };
  }
};
